import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { SymbolTilesMessage } from 'communication/types/symbolTiles/SymbolTilesElement';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import { Store } from 'redux';
import {
    handleSymbolTilesStreamError,
    handleSymbolTilesStreamMessageBatch,
    watchSymbolTilesStream,
} from 'widgets/symbolTile/store/data/actions';
import IntervalBuffer from 'utils/IntervalBuffer';

export function getSymbolTilesMessageHandler(
    store: Store
): StreamDataHandlers<SymbolTilesMessage> {
    const dispatch = store.dispatch;

    const buffer: IntervalBuffer<SymbolTilesMessage> = new IntervalBuffer(
        (data: SymbolTilesMessage[]) =>
            dispatch(handleSymbolTilesStreamMessageBatch(data))
    );

    return {
        onPending: (streamKey: string) =>
            dispatch(watchSymbolTilesStream(streamKey)),
        onMessage: (_streamKey: string, message: SymbolTilesMessage) => {
            buffer.in([message]);
        },
        onError: (_streamKey: string, error: StreamError) => {
            dispatch(handleSymbolTilesStreamError(error));
        },
    };
}
